<template>
<div>

    <!-- barre progression top -->
        <div class="headerB">
            <div class="progress-container">
                <div class="progress-bar" id="myBar"></div>
            </div>
        </div>


    <!-- Conteneur Welcome Image -->
        <div class="welcome"> 
                <div>
                    <div id="nomPrenom">{{nomPrenom}}</div>
                    <h1>{{poste}}</h1>
                    <a href="#quiSuisJe">
                    <div class="aboutMeLink">{{texteBouton}}</div>
                    </a>
                </div>   
        </div>      
 
</div>
</template>


<script>
    export default {
    name: 'headerV',
        data() {    
        return    {
                    nomPrenom : 'Emmanuel Trépant',
                    poste : 'Web Designer SENIOR  |  Front-End Développeur',
                    texteBouton : 'Qui suis-je ?'             
                }                   
    }};

// Barre de progression - OK
        window.onscroll = function () {
            barreProgression()
        };

        function barreProgression() {
            let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            let scrolled = (winScroll / height) * 100;
            document.getElementById("myBar").style.width = scrolled + "%";
        }

</script>

<style scoped>

/* liste images  */

    .welcome {
    background-color: black;
    background-image: url("../assets/images/1a.jpg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 750px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /* anim */
    animation: fadeIn ease 5s;
    -webkit-animation: fadeIn ease 5s;
    -moz-animation: fadeIn ease 5s;
    -o-animation: fadeIn ease 5s;
    -ms-animation: fadeIn ease 5s;
    }

/* Intro image en FadeIn */

    .fade-in {
    animation: fadeIn ease 5s;
    -webkit-animation: fadeIn ease 5s;
    -moz-animation: fadeIn ease 5s;
    -o-animation: fadeIn ease 5s;
    -ms-animation: fadeIn ease 5s;
    }


    @keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
    }

    @-moz-keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
    }

    @-webkit-keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
    }

    @-o-keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
    }

    @-ms-keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
    }

    #nomPrenom {
        font-size: 55px;
        color: white;
        -webkit-text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
        -moz-text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
        -o-text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
        -ms-text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
        text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
    }

    .aboutMeLink
    {
        border: 1px solid white;
        font-size: 14px;
        font-weight: bolder;
        color: white;
        padding: 16px 60px;
        margin-top: 15px;
        display: inline-block;
        border-radius: 3px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        opacity: 1;
        transition: 1s;
    }

    .aboutMeLink:hover
    {
        background-color: white;
        color: #428bca;
        -webkit-box-shadow: 6px 10px 12px -4px rgba(0, 0, 0, 0.4);
        -moz-box-shadow: 6px 10px 12px -4px rgba(0, 0, 0, 0.4);
        box-shadow: 6px 10px 12px -4px rgba(0, 0, 0, 0.4);
        opacity: 1;
    }

    /* Animation Bar de progression */
    .headerB {
    position: fixed;
    top: 0;
    z-index: 300;
    width: 100%;
    /* background-color: black; */
    }

    .headerB h2 {
    text-align: center;
    }

    .progress-container {
    width: 100%;
    height: 2px;
    background: #8ac7e4;
    }

    .progress-bar {
    height: 2px;
    background: #306ea3;
    width: 0%;
    }

/* --------------------------------- 1024 px  */
    @media only screen and (max-width: 1024px) {

    .welcome {
    height: 500px;}

    #nomPrenom {
    font-size: 40px;
    }

    h1{
    font-size: 20px;
    }
}
</style>



